import { render, staticRenderFns } from "./PromotionActivitiesEdit.vue?vue&type=template&id=3836de2d&scoped=true&"
import script from "./PromotionActivitiesEdit.vue?vue&type=script&lang=js&"
export * from "./PromotionActivitiesEdit.vue?vue&type=script&lang=js&"
import style0 from "./PromotionActivitiesEdit.vue?vue&type=style&index=0&id=3836de2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3836de2d",
  null
  
)

export default component.exports